export default __webpack_public_path__ + "static/media/EDIT_PENCIL.3518092c.svg";